import { render, staticRenderFns } from "./Webtop.vue?vue&type=template&id=038e6b0c"
import script from "./Webtop.vue?vue&type=script&lang=js"
export * from "./Webtop.vue?vue&type=script&lang=js"
import style0 from "./Webtop.vue?vue&type=style&index=0&id=038e6b0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports